import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

export interface EnergyLabelDistributionItem {
  percentage: number;
  colorClass: string;
  label: string;
  translation: string;
  /** EPC: merged A+ / "A or higher" band when the portfolio chart combines A or higher. */
  epcAOrHigherBand?: boolean;
}

@Component({
  selector: 'cfp-energy-label-distribution',
  templateUrl: 'energy-label-distribution.html',
  imports: [TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EnergyLabelDistribution {
  public readonly energyLabels = input.required<EnergyLabelDistributionItem[]>();
  public readonly showLabel = input<boolean>(false);
}
